// extracted by mini-css-extract-plugin
export var quantityInput = "_fk-0";